import type { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { formatPhone, phoneToDialable } from '#/shared/lib/format'
import { useStartCall } from '#/shared/lib/telephony'
import { cn } from '#/shared/lib/utils'
import { PhoneIcon } from '#/shared/ui/icons'

const BUTTON =
  'flex size-10 shrink-0 items-center justify-center rounded-full bg-avatar-green-soft text-avatar-green'

function stop(event: MouseEvent) {
  event.stopPropagation()
}

/** Green circular call button shown on the right of the card's contact row. */
export function CallButton({ phone }: { phone?: string }) {
  const { t } = useTranslation()
  const { call, phoneUp } = useStartCall()
  const dialable = phoneToDialable(phone)
  if (!dialable) return null

  const ariaLabel = t('phone.callAria', { number: formatPhone(phone) })
  const icon = <PhoneIcon className="size-4.5" />

  if (phoneUp) {
    return (
      <button
        type="button"
        aria-label={ariaLabel}
        onClick={(event) => {
          stop(event)
          call(dialable)
        }}
        className={cn(BUTTON, 'cursor-pointer transition active:scale-90')}
      >
        {icon}
      </button>
    )
  }

  return (
    <a
      href={`tel:${dialable}`}
      aria-label={ariaLabel}
      onClick={stop}
      className={BUTTON}
    >
      {icon}
    </a>
  )
}
